import { DRUG_PATH } from "@/constants";

export const DRUG_LIST_PATH = "list";

export const getDrugListUrl = () => `/${DRUG_PATH}/${DRUG_LIST_PATH}`;
